import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule, CardModule } from '@liberty-financial/ng-components';

import { SharedModule } from '@shared/shared.module';

import { SparkSharedDataTableWrapperComponent } from './data-table-wrapper/data-table-wrapper.component';
import { SparkSharedPaginationModule } from '../pagination/pagination.module';

@NgModule({
  declarations: [SparkSharedDataTableWrapperComponent],
  imports: [
    CommonModule,
    SparkSharedPaginationModule,
    ButtonModule,
    CardModule
  ],
  exports: [SparkSharedDataTableWrapperComponent]
})
export class SparkSharedDataTableModule {}
